export const APP_TOAST_EVENT = 'app:toast'

export const emitAppToast = ({ title = '', message = '', tone = 'info', timeout = 3200 } = {}) => {
  if (typeof window === 'undefined') return

  window.dispatchEvent(new CustomEvent(APP_TOAST_EVENT, {
    detail: {
      id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
      title,
      message,
      tone,
      timeout,
    },
  }))
}
